import { Component, Input } from '@angular/core';
import { AppSettings } from '../../../app/app.settings';

@Component({
	selector: 'i-code-prompt',
	template: require('./i-code-prompt.template.html'),
})
export class ICodePromptComponent {
	@Input() isOnboardingFlow: boolean = false;
	@Input() isNewChangePasswordModals: boolean = false;
	@Input() isGroupUserIdsBigModalEnabled: boolean = false;
	@Input() text: string = 'Για να προχωρήσετε, εισάγετε τον 6ψήφιο κωδικό OTP που μόλις λάβατε στο κινητό σας.';
	@Input() isEmailUnlockUser: boolean = false;
	public isRebrading = AppSettings.isRebrading;
	public textOnboarding: string =
		'Για να προχωρήσετε, εισάγετε τον 6ψήφιο κωδικό OTP που μόλις λάβατε στο κινητό σας.';

	public showText(): string {
		if (this.isOnboardingFlow == true || this.isNewChangePasswordModals == true) {
			return this.textOnboarding;
		} else {
			return this.text;
		}
	}
}
